import React, { useEffect, useState, useRef } from 'react';
import { Image as AntdImage, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from "react-redux";

import aiIcon from "../../assets/img/V7/aiIcon.svg";
import aiText from "../../assets/img/V7/aiText.svg";
import QASearchInput from "../qASearchInput/index"
import UploadFileIcon from "../qASearchInput/uploadFileIcon.js"
import { setAIModalState } from "../../features/AIIntelligentV7/AIReducer";
import './index.scss';
import Iconfont from '../Iconfont/Iconfont.js';
const AIQAPage = ({
    pageType,
}) => {

    const dispatch = useDispatch();
    const QAKowledgeList = useSelector(state => state.AIReducerV7.QAKowledgeList);
    const [smallScreen, setSmallScreen] = useState(false);

    useEffect(() => { 
        console.log(pageType,"pageType")
        handleResize();

        // 添加事件监听器
        window.addEventListener('resize', handleResize);

        // 组件卸载时移除事件监听器
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [])

    useEffect(() => { 
        console.log('QAKowledgeList', QAKowledgeList)

    }, [JSON.stringify(QAKowledgeList)])

    const handleResize = () => {
        console.log(`Window size: ${window.innerWidth} x ${window.innerHeight}`);
        if(window.innerWidth < 1500){
            setSmallScreen(true);
        }else{
            setSmallScreen(false);
        }
    }; 

    const deleteFile = (items) => { 

        let newQAKowledgeList = QAKowledgeList.filter(item => {
            let id = item.id || item.knowledgeId || item.policyId || item.elasticId;
            let deleteId = items.id || items.knowledgeId || items.policyId || items.elasticId;
            return id !== deleteId
        })

        dispatch(setAIModalState({
            "QAKowledgeList":[
                ...newQAKowledgeList,
            ]
        }))
    }
    
    return (<div className="knowledgeContentAI" style={smallScreen?{width: '369px'}:{width: '469px'}}>
        <div className="knowledgeContentAITopBox">
            {QAKowledgeList && QAKowledgeList.length > 0 ? <div className="knowledgeFileList">
                <div className="knowledgeContentAIImg">
                    <AntdImage
                        preview={false}
                        src={aiIcon}
                    />
                    <AntdImage
                        preview={false}
                        src={aiText}
                    />
                </div>
                <div className="knowledgeContentAIText">已添加如下文件，可就这些文件提问进一步探索</div>
                <div className="fileList">
                    {QAKowledgeList.map((item, index) => { 
                        return <div className="fileListItem" key={index}>
                            <UploadFileIcon fileType={item.fileType}/>
                            <div>{item.title || item.knowledgeTitle || item.knowledgeName}</div>
                            <Popconfirm 
                            placement="left" 
                            title={'请确认是否删除添加的知识'} 
                            onConfirm={()=>deleteFile(item)} 
                            okText="确定" 
                            cancelText="取消">
                                <Iconfont type="icon-cuowu"/>
                            </Popconfirm>
                        </div>
                    })}
                </div>
                
            </div>:<div className="knowledgeContentAITitle">
                <div className="knowledgeContentAIImg">
                    <AntdImage
                        preview={false}
                        src={aiIcon}
                    />
                    <AntdImage
                        preview={false}
                        src={aiText}
                    />
                </div>
                <div className="knowledgeContentAIText">查资料、读文件、解疑惑、做分析一起来挖掘更多实用功能吧！</div>
            </div>}
        </div>
        
        <div className="knowledgeContentAIBottomBox">
            <QASearchInput 
                pageType={'knowledgeCentre'}
                scopeQA={pageType}
            />
        </div>
        
    </div>)
}


export default AIQAPage;